import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant, FIELD_COMPONENT, MODULE_NAME } from 'app/config/constants';
import { DialogConfirmWithMultipleMessagesComponent } from 'app/dialog/dialog-confirm-with-multiple-messages/dialog-confirm-with-multiple-messages.component';
import { DialogSetUpARefundCertificateComponent } from 'app/dialog/dialog-set-up-a-refund-certificate/dialog-set-up-a-refund-certificate.component';
import { PriceTableComponent } from 'app/dialog/price-table/price-table.component';
import { Common } from 'app/model/entity/common';
import { Ticket } from 'app/model/entity/ticket';
import { ContentDayReservation } from 'app/model/entity/ticket-editor/content-day-reservation';
import { ApplicationDTO } from 'app/model/entity/ticket-editor/dto/application-DTO';
import { Is29hNotation } from 'app/model/entity/ticket-editor/stock';
import { CommonService } from 'app/service/common.service';
import { DialogService } from 'app/service/dialog.service';
import { TicketEditorService } from 'app/service/ticket-editor.service';
import { AppState } from 'app/store/app.state';
import _ from 'lodash';
import moment from 'moment';
import { DatePickerDirective } from 'ng2-date-picker';
import { forkJoin, Subscription } from 'rxjs';
import { Stock } from './../../../model/entity/ticket-editor/stock';
import { MenuActionService } from 'app/service/menu-action.service';
import { DialogTicketQuantityDisplaySettingsComponent } from 'app/dialog/dialog-ticket-quantity-display-settings/dialog-ticket-quantity-display-settings.component';
import { CommonTableService } from 'app/service/common-table.service';
import { CommonTable } from 'app/model/entity/commonTable';
import { TicketQuantityDisplaySetting } from 'app/model/entity/ticket-quantity-display-settings';

@Component({
  selector: 'tab-reservation',
  templateUrl: './tab-reservation.component.html',
  styleUrls: ['./tab-reservation.component.scss']
})
export class TabReservationComponent implements OnInit {
  @Input() tabSelected: number; // tab selected
  @Input() informationAccount: any;
  @Output() reservationManagementOutPut: EventEmitter<any> = new EventEmitter<any>();
  @Output() rservationRegistrationOutPut: EventEmitter<any> = new EventEmitter<any>();
  /**
   * constant
   */
  Constant = Constant;
  private readonly FORMAT_DATE = 'YYYY-MM-DD';

  /**
   * month selected
   */
  selectedMonthInCalendarMonth: any;

  selectedMonthInCalendarWeek: any;

  isPreviousMonth: boolean;

  /**
   * true if > finish month
   */
  isNextMonth: boolean;

  /**
   * year selected
   */
  selectedYear: number;

  /**
   * common object
   */
  commonObject: Common;

  /**
   * current date
   */
  currentDate: Date = new Date();

  /**
   * content days month
   */
  contentDaysMonth: Array<ContentDayReservation>;

  contentDaysWeek: Array<ContentDayReservation>;

  /**
   * list month
   */
  listMonth: Array<{ value: string; key: number }> = Array(
    { value: this.translateService.instant('schedule-merge.month-1'), key: 0 },
    { value: this.translateService.instant('schedule-merge.month-2'), key: 1 },
    { value: this.translateService.instant('schedule-merge.month-3'), key: 2 },
    { value: this.translateService.instant('schedule-merge.month-4'), key: 3 },
    { value: this.translateService.instant('schedule-merge.month-5'), key: 4 },
    { value: this.translateService.instant('schedule-merge.month-6'), key: 5 },
    { value: this.translateService.instant('schedule-merge.month-7'), key: 6 },
    { value: this.translateService.instant('schedule-merge.month-8'), key: 7 },
    { value: this.translateService.instant('schedule-merge.month-9'), key: 8 },
    { value: this.translateService.instant('schedule-merge.month-10'), key: 9 },
    { value: this.translateService.instant('schedule-merge.month-11'), key: 10 },
    { value: this.translateService.instant('schedule-merge.month-12'), key: 11 }
  );

  /**
   * array subscription
   */
  subscriptions: Array<Subscription> = new Array<Subscription>();

  /**
   * return value selects the time table
   */

  selectTable: string = 'weekly';

  /**
   * returns true if you choose to display details by month
   */

  isShowDetailByMonth: boolean = false;

  /**
   * returns true if you choose to display details by week
   */

  isShowDetailByWeek: boolean = false;
  listApp: ApplicationDTO[] = []; // list Application
  listTicket: Ticket[] = [];
  appIdSelected: string;
  ticketIdSelected: number;
  time: any;
  public languageKey: string;
  weekSelected: any;
  config: any;
  dayInMonthSelected: ContentDayReservation;
  stockSelectFromWeeklyCalendar: Stock;
  resultApiA1: any;
  ticketQuantityDisplaySetting: TicketQuantityDisplaySetting;
  isSoldTickets: boolean;

  constructor(
    private commonService: CommonService,
    public translateService: TranslateService,
    public readonly store: Store<AppState>,
    private ticketEditorService: TicketEditorService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private dialogService: DialogService,
    private actionService: MenuActionService,
    private commonTableService: CommonTableService
  ) {
    this.subscriptions.push(this.store.select(state => state).subscribe());
    this.subscriptions.push(
      this.actionService.actionTicketQuantityDisplaySetting.subscribe(moduleName => {
        if (moduleName == MODULE_NAME[FIELD_COMPONENT.TicketManagerComponent]) {
          this.setTicketQuantityDisplay();
        }
      })
    );
    this.commonObject = this.commonService.getCommonObject();
    this.currentDate = Helper.getCurrentByTimezoneSetting(this.commonObject);
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe(() => {
        this.languageKey = this.commonService.getCommonObject().setting?.language;
        // multiple language column header
        this.listMonth = [
          { value: this.translateService.instant('schedule-merge.month-1'), key: 0 },
          { value: this.translateService.instant('schedule-merge.month-2'), key: 1 },
          { value: this.translateService.instant('schedule-merge.month-3'), key: 2 },
          { value: this.translateService.instant('schedule-merge.month-4'), key: 3 },
          { value: this.translateService.instant('schedule-merge.month-5'), key: 4 },
          { value: this.translateService.instant('schedule-merge.month-6'), key: 5 },
          { value: this.translateService.instant('schedule-merge.month-7'), key: 6 },
          { value: this.translateService.instant('schedule-merge.month-8'), key: 7 },
          { value: this.translateService.instant('schedule-merge.month-9'), key: 8 },
          { value: this.translateService.instant('schedule-merge.month-10'), key: 9 },
          { value: this.translateService.instant('schedule-merge.month-11'), key: 10 },
          { value: this.translateService.instant('schedule-merge.month-12'), key: 11 }
        ];
        this.updateConfig();
        this.handleLanguageChange();
      })
    );
  }

  private async handleLanguageChange() {
    if (this.appIdSelected && this.appIdSelected != '-1' && this.ticketIdSelected && this.ticketIdSelected != -1) {
      if (!this.isShowDetailByWeek) {
        await this.changeTicket();
      } else {
        const temp = _.cloneDeep(this.stockSelectFromWeeklyCalendar);
        await this.changeTicket();
        for (const element of this.contentDaysWeek) {
          const stockArr = element?.stock;
          if (stockArr && stockArr.length) {
            const indexStock = stockArr.findIndex(item => item?.stockId == temp?.stockId);
            if (indexStock !== -1) {
              await this.showDetailByWeek(stockArr[indexStock]);
            }
          }
        }
      }
    }
  }

  async ngOnInit(): Promise<void> {
    this.languageKey = this.commonObject?.setting?.language;
    if (!this.selectedMonthInCalendarMonth) {
      this.currentDate = new Date();
      this.selectedYear = _.cloneDeep(this.currentDate.getFullYear());
      this.selectedMonthInCalendarMonth = _.cloneDeep(this.currentDate.getMonth());
    }
    if (!this.selectedMonthInCalendarWeek) {
      this.weekSelected = this.convertDateToFormatYYYYMMDDD(this.currentDate);
      // this.selectedMonthInCalendarWeek = (moment(this.weekSelected, this.FORMAT_DATE).isoWeeks() + '').padStart(2, '0');
      this.selectedMonthInCalendarWeek = this.getWeekNumberStartingSunday(this.weekSelected);
    }
    this.contentDaysMonth = _.cloneDeep(
      Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
    );
    this.contentDaysWeek = _.cloneDeep(
      Helper.getOneWeekCalendar(this.selectedYear, this.selectedMonthInCalendarWeek, this.commonObject, this.weekSelected)
    );
    this.updateConfig();
    await this.getAllApplication();
    this.commonTableService.getValueCommonTableByKey(Constant.KEY_TICKET_QUANTITY_DISPLAY_SETTINGS).subscribe(result => {
      if (result) {
        this.ticketQuantityDisplaySetting = JSON.parse(result.value);
        this.isSoldTickets = this.ticketQuantityDisplaySetting.isSoldTicket;
      } else {
        this.isSoldTickets = true;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  showPrevMonth(): void {
    this.isPreviousMonth = false;
    this.isNextMonth = false;
    this.selectedMonthInCalendarMonth = this.selectedMonthInCalendarMonth <= 0 ? 11 : this.selectedMonthInCalendarMonth - 1;
    this.selectedYear = this.selectedMonthInCalendarMonth == 11 ? this.selectedYear - 1 : this.selectedYear;
    this.contentDaysMonth = _.cloneDeep(
      Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
    );
  }

  showNextMonth(): void {
    this.isNextMonth = false;
    this.isPreviousMonth = false;
    this.selectedMonthInCalendarMonth = this.selectedMonthInCalendarMonth >= 11 ? 0 : this.selectedMonthInCalendarMonth + 1;
    this.selectedYear = this.selectedMonthInCalendarMonth == 0 ? this.selectedYear + 1 : this.selectedYear;
    this.contentDaysMonth = _.cloneDeep(
      Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
    );
  }

  /**
   * select month
   * @param month
   */
  selectMonth(month: any): void {
    this.selectedMonthInCalendarMonth = +month;
    // get calendar by selected month and selected year
    this.contentDaysMonth = _.cloneDeep(
      Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
    );
  }

  /**
   * change display mode
   * @param time
   */
  changeDisplayMode(time: any): void {
    // xử lí nếu có 2 mode
  }

  /**
   * show Detail by Month
   */
  showDetailByMonth(day: ContentDayReservation): void {
    this.isShowDetailByMonth = !this.isShowDetailByMonth;
    if (this.isShowDetailByMonth) {
      this.dayInMonthSelected = day;
    } else {
      this.dayInMonthSelected = undefined;
    }
  }

  /**
   * show Detail by week
   */
  async showDetailByWeek(stock?: Stock): Promise<void> {
    if (this.stockSelectFromWeeklyCalendar?.stockId == stock.stockId) {
      this.isShowDetailByWeek = false;
      this.stockSelectFromWeeklyCalendar = undefined;
    } else {
      this.isShowDetailByWeek = true;
      this.stockSelectFromWeeklyCalendar = stock;
      const datePart = this.stockSelectFromWeeklyCalendar.reserveOn.split('T')[0];
      const [yearStr, monthStr] = datePart.split('-');
      const year = parseInt(yearStr, 10);
      const month = parseInt(monthStr, 10);
      await this.ticketEditorService
        .reservationPrices(
          this.informationAccount,
          null,
          this.stockSelectFromWeeklyCalendar.ticketId,
          year,
          month,
          this.stockSelectFromWeeklyCalendar.reservationClassId,
          this.stockSelectFromWeeklyCalendar.dynamicPriceType
        )
        .subscribe(res => {
          if (!res) {
            return;
          }
          res.forEach(element => {
            if (
              element?.reservationPriceId == this.stockSelectFromWeeklyCalendar.reservationPriceId &&
              element?.reservationClassId == this.stockSelectFromWeeklyCalendar.reservationClassId
            ) {
              this.resultApiA1 = element;
            }
          });
        });
    }
  }

  getTitleSelected(appId: string, ticketId: number, mode: string): string {
    if (mode == 'app') {
      let indexApp = this.listApp.findIndex(e => e.appId == appId);
      if (indexApp == -1) {
        return '';
      } else {
        return this.listApp[indexApp].appName;
      }
    } else if (mode == 'ticket') {
      let indexTicket = this.listTicket.findIndex(e => e?.ticketId == ticketId);
      if (indexTicket == -1) {
        return '';
      }
      return this.languageKey == 'en' ? this.listTicket[indexTicket]?.ticketName?.en : this.listTicket[indexTicket]?.ticketName?.ja;
    }
  }

  changeDisplay(value: String): String {
    let temp = _.cloneDeep(value)?.toString();
    if (temp?.split('W')?.length > 7 && temp?.length > 20) {
      value = value?.substring(0, 19) + '...';
    } else if (value?.length > 35) {
      value = value?.substring(0, 33) + '...';
    }
    return value;
  }

  /**
   * get list application
   * @param appSelect
   */
  async getAllApplication(): Promise<void> {
    return new Promise<void>(resolve => {
      this.ticketEditorService.findAllApplication(this.informationAccount).subscribe(res => {
        this.listApp = Helper.convertResApplication(res);
        resolve();
      });
    });
  }

  async getTicketByAppId(): Promise<void> {
    if (!this.appIdSelected || this.appIdSelected == '-1') {
      this.clearValue('app');
    } else {
      await this.ticketEditorService.getTickets(this.informationAccount, this.appIdSelected, null, true).subscribe(res => {
        this.clearValue('app');
        this.listTicket = res;
      });
    }
  }

  clearValue(modeChange: string) {
    if (modeChange == 'app') {
      this.ticketIdSelected = -1;
      this.listTicket = [];
    }
    if (modeChange != 'time') {
      this.contentDaysMonth = _.cloneDeep(
        Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
      );
      this.onDateChange();
    }
    this.isShowDetailByMonth = false;
    this.isShowDetailByWeek = false;
    this.dayInMonthSelected = undefined;
    this.stockSelectFromWeeklyCalendar = undefined;
    this.resultApiA1 = undefined;
  }
  /**
   * open date picker
   * @param time selected
   * @param isFrom true if open date picker time from
   */
  openDatePicker(picker: DatePickerDirective, time: any) {
    picker.api.open();
    this.addPseudoSpan();
    picker.api.moveCalendarTo(time ?? moment());
  }

  addPseudoSpan(): void {
    while (document.getElementById('span-new')) {
      document.getElementById('span-new').remove();
    }
    return;
  }

  /**
   * update config for picker
   *
   * @param period
   */
  private updateConfig(): void {
    this.config = {
      showWeekNumbers: false,
      format: this.FORMAT_DATE,
      firstDayOfWeek: 'su',
      unSelectOnClick: false,
      locale: Helper.getLocale(this.languageKey),
      min: '2023-01-01'
    };
  }

  /**
   * onDateChange
   */
  onDateChange() {
    this.clearValue('time');
    //this.selectedMonthInCalendarWeek = (moment(this.weekSelected, this.FORMAT_DATE).isoWeeks() + '').padStart(2, '0');
    this.selectedMonthInCalendarWeek = this.getWeekNumberStartingSunday(this.weekSelected);
    const dataDate = new Date(this.weekSelected);
    const year = dataDate.getFullYear();
    this.contentDaysWeek = _.cloneDeep(
      Helper.getOneWeekCalendar(year, this.selectedMonthInCalendarWeek, this.commonObject, this.weekSelected)
    );
    this.cdr.detectChanges();
  }

  /**
   * convertDate
   * @param fullDate
   * @param languageKey
   * @returns
   */
  convertDate(fullDate, languageKey) {
    if (!fullDate) {
      return '';
    }
    // Parse the fullDate string into a Date object
    const date = new Date(fullDate);

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Format the date based on the language key
    if (languageKey == 'jp') {
      return `${year}年${month}月 `;
    } else if (languageKey == 'en') {
      return `${date.toLocaleString('en-US', { month: 'long', year: 'numeric' })} `;
    }
  }

  /**
   * changeTicket
   */
  async changeTicket(): Promise<void> {
    if (this.ticketIdSelected && this.ticketIdSelected !== -1) {
      let time =
        this.selectTable == 'monthly'
          ? this.getStartAndEndDateOfMonth(this.contentDaysMonth)
          : this.getStartAndEndDateOfMonth(this.contentDaysWeek);

      let resApi = await this.ticketEditorService
        .getStockByStockPartitionId(this.informationAccount, null, this.ticketIdSelected, time.startDate, time.endDate)
        .toPromise();

      if (!resApi) {
        return;
      }

      this.clearValue('ticket');
      resApi.forEach(element => {
        if (!element.is29hNotation) {
          element.reserveOnIs29hNotation = this.convertToIs29hNotation(element.reserveOn, false);
        } else {
          let reserveOnClone = _.cloneDeep(element.reserveOn);
          element.reserveOn = this.convertTimeIs29h(reserveOnClone, true);
          element.reserveOnIs29hNotation = this.convertToIs29hNotation(reserveOnClone, true);
        }
      });

      if (this.selectTable == 'monthly') {
        this.contentDaysMonth = _.cloneDeep(
          Helper.getOneMonthCalendar(this.selectedMonthInCalendarMonth, this.selectedYear, this.commonObject)
        );
        this.contentDaysMonth.forEach(contentDay => {
          if (!contentDay.isOtherMonth) {
            const contentDate = this.datePipe.transform(contentDay.fullDate, 'yyyy-MM-dd');
            resApi.forEach(stock => {
              const stockDate = stock.reserveOn.split('T')[0];

              if (stockDate.includes(contentDate)) {
                if (!contentDay.stock) {
                  contentDay.stock = [];
                  contentDay.stock.push(stock);
                } else {
                  contentDay.stock.push(stock);
                }
              }
            });
          }
        });

        this.contentDaysMonth.forEach(e => {
          if (e.stock && e.stock.length > 0) {
            e.stock.sort(this.compareStock.bind(this));
          }
        });
      } else {
        this.onDateChange();
        this.contentDaysWeek.forEach(contentDay => {
          if (!contentDay.isOtherMonth) {
            const contentDate = this.datePipe.transform(contentDay.fullDate, 'yyyy-MM-dd');
            resApi.forEach(stock => {
              const stockDate = stock.reserveOn.split('T')[0];

              if (stockDate.includes(contentDate)) {
                if (!contentDay.stock) {
                  contentDay.stock = [];
                  contentDay.stock.push(stock);
                } else {
                  contentDay.stock.push(stock);
                }
              }
            });
          }
        });

        this.contentDaysWeek.forEach(e => {
          if (e.stock && e.stock.length > 0) {
            e.stock.sort(this.compareStock.bind(this));
          }
        });
      }
    } else {
      this.clearValue('ticket');
    }
  }

  /**
   * convertToIs29hNotation
   *
   * nếu is29hNotation thì lùi lại 1 ngày + thời gian tăng thêm 24h
   *
   * @param dateString
   * @param is29hNotation
   * @returns
   */
  convertToIs29hNotation(dateString: string, is29hNotation: boolean): Is29hNotation {
    if (!dateString) {
      return;
    }
    let day;
    let time;
    const array = dateString.split('T');
    if (!is29hNotation) {
      day = array[0];
      time = array[1].substring(0, 5);
    } else {
      const dayAfter = array[0];
      const date = new Date(dayAfter);
      day = date.setDate(date.getDate() - 1);
      day = this.datePipe.transform(day, 'yyyy-MM-dd');
      const hours = parseInt(array[1].substring(0, 2)) + 24;
      const formattedHours = hours.toString();
      const minutes = array[1].substring(3, 5);
      time = `${formattedHours}:${minutes}`;
    }

    return {
      day: day,
      time: time
    };
  }

  convertTimeIs29h(inputTime: string, is29hNotation: boolean = false): string {
    // Chuyển đổi chuỗi thời gian thành đối tượng Date
    if (!inputTime) {
      return;
    }
    const arrayDate = inputTime.split('T');
    let date = new Date(arrayDate[0]);
    if (is29hNotation) {
      // Lùi 1 ngày trước
      date.setDate(date.getDate() - 1);
      const hours = parseInt(arrayDate[1].substring(0, 2), 10) + 24;
      // Lấy các thành phần của thời gian
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      // Tạo chuỗi kết quả
      const outputTime = `${year}-${month}-${day}T${hours}${arrayDate[1].substring(2, arrayDate[1].length)}`;
      return outputTime;
    } else {
      return inputTime;
    }
  }

  /**
   * getStartAndEndDateOfMonth
   * @param contentDaysMonth
   * @returns
   */
  getStartAndEndDateOfMonth(contentDaysMonth: ContentDayReservation[]): { startDate: string; endDate: string } {
    const daysOfMonth = contentDaysMonth.filter(day => !day.isOtherMonth);
    if (daysOfMonth?.length === 0) {
      return { startDate: '', endDate: '' };
    }
    const startDate = this.convertDateToFormatYYYYMMDDD(new Date(daysOfMonth[0].fullDate));
    const endDate = this.convertDateToFormatYYYYMMDDD(new Date(daysOfMonth[daysOfMonth.length - 1].fullDate));

    return { startDate, endDate };
  }

  /**
   * convertDateToFormatYYYYMMDDD
   * @param date
   * @returns
   */
  convertDateToFormatYYYYMMDDD(date: Date): string {
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date
      .getDate()
      .toString()
      .padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * compareStock
   * @param a
   * @param b
   * @returns
   */
  compareStock(a: Stock, b: Stock): number {
    if (a.reserveOnIs29hNotation.time < b.reserveOnIs29hNotation.time) return -1;
    if (a.reserveOnIs29hNotation.time > b.reserveOnIs29hNotation.time) return 1;

    if (a.tripId < b.tripId) return -1;
    if (a.tripId > b.tripId) return 1;

    if (a.reservationClassId < b.reservationClassId) return -1;
    if (a.reservationClassId > b.reservationClassId) return 1;

    return 0;
  }

  /**
   * getTheDayOfTheWeek
   * @param date
   * @returns
   */
  getTheDayOfTheWeek(date: Date): string {
    if (!date) {
      return '';
    }
    const dayOfWeekMapJp = ['日', '月', '火', '水', '木', '金', '土'];
    const dayOfWeekMapEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = this.languageKey == 'en' ? dayOfWeekMapEn[date.getDay()] : dayOfWeekMapJp[date.getDay()];

    if (this.languageKey == 'en') {
      return `${year}/${month}/${day} (${dayOfWeek})`;
    } else if (this.languageKey == 'jp') {
      return `${year}年${month}月${day}日(${dayOfWeek})`;
    }
  }

  /**
   * getLabelStockQuantity
   * @param contentday
   * @returns
   */
  getLabelStockQuantity(contentday: ContentDayReservation): string {
    if (!contentday || !contentday.stock) {
      return '';
    }
    if (contentday && contentday.stock && contentday.stock.length) {
      return Helper.formatString(this.translateService.instant(`ticket-manager.tab-reservation.other-item`), `${contentday.stock.length}`);
    }
  }

  /**
   * getLabgetLabelHeaderweeklySchedule
   * @param date
   * @returns
   */
  getLabgetLabelHeaderweeklySchedule(date: Date): string {
    const dayOfWeekMapJp = ['日', '月', '火', '水', '木', '金', '土'];
    const dayOfWeekMapEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const month = date.getMonth() + 1; // Tháng trong Date bắt đầu từ 0
    const day = date.getDate();
    const dayOfWeek = this.languageKey == 'en' ? dayOfWeekMapEn[date.getDay()] : dayOfWeekMapJp[date.getDay()];

    return `${month}/${day} ${dayOfWeek}`;
  }

  /**
   * rservationRegistration
   */
  rservationRegistration(): void {
    const dataReservationRegistration = {
      ticketId: this.stockSelectFromWeeklyCalendar.ticketId,
      ticketName: this.stockSelectFromWeeklyCalendar.ticketName,
      reserveOn: this.stockSelectFromWeeklyCalendar.reserveOn,
      reservationClassId: this.stockSelectFromWeeklyCalendar.reservationClassId,
      tripId: this.stockSelectFromWeeklyCalendar.tripId,
      reservationStatus: 'approved'
    };
    this.rservationRegistrationOutPut.emit(dataReservationRegistration);
  }

  /**
   * reservationManagement
   */
  reservationManagement(): void {
    const dataSearch = {
      reserveOn: this.stockSelectFromWeeklyCalendar.reserveOn,
      tripId: this.stockSelectFromWeeklyCalendar.tripId,
      reservationClassId: this.stockSelectFromWeeklyCalendar.reservationClassId,
      appId: this.appIdSelected,
      ticketId: this.ticketIdSelected
    };

    this.reservationManagementOutPut.emit(dataSearch);
  }

  /**
   * enable
   */
  enable() {
    this.changeTicket();
  }

  getWeekNumberStartingSunday(dateString: string): string {
    // Chuyển đổi chuỗi ngày thành đối tượng moment
    const date = moment(dateString, this.FORMAT_DATE);
    // Tính số tuần từ ngày đầu tiên của tuần đầu tiên đến ngày được chọn
    let weekNumber;
    if (this.languageKey == 'en') {
      weekNumber = date.day() == 0 ? moment(date).week() + 1 : moment(date).week();
    } else {
      weekNumber = moment(date).week();
    }

    weekNumber = weekNumber > 52 ? 1 : weekNumber;
    // Định dạng kết quả để có ít nhất 2 chữ số
    return weekNumber.toString().padStart(2, '0');
  }

  /**
   * isEmpty
   * @param value
   * @returns
   */
  isEmpty(value): boolean {
    if (!value) {
      if (typeof value == 'number' && value == 0) {
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   * getSoldTicketOrRemainingSeats
   * @param maxReservationCount
   * @param currentReservationCount
   * @returns
   */
  getSoldTicketOrRemainingSeats(maxReservationCount: number, currentReservationCount: number) {
    if (!this.isEmpty(maxReservationCount) && !this.isEmpty(currentReservationCount)) {
      if (this.isSoldTickets) {
        return `${currentReservationCount}`;
      } else {
        return `${maxReservationCount - currentReservationCount} / ${maxReservationCount}`;
      }
    }
    return '';
  }

  /**
   * isActiveButton
   */
  isActiveButton(): boolean {
    if (!this.stockSelectFromWeeklyCalendar) {
      return false;
    }
    let currentDate = new Date(this.stockSelectFromWeeklyCalendar?.reserveOnIs29hNotation?.day);
    currentDate.setHours(0, 0, 0, 0);
    const currentDateByTimeZone = Helper.getCurrentByTimezoneSetting(this.commonObject, true);
    return currentDate >= currentDateByTimeZone;
  }

  /**
   * setBackgroundBlock
   * @param stock
   * @returns
   */
  setBackgroundBlock(stock): string {
    const inventoryNumber = stock?.maxReservationCount - stock?.currentReservationCount;
    if (inventoryNumber == 0) {
      return '#a9a9a9';
    }
    if (_.isEqual(stock.saleTypes, Constant.APPOINTMENTS_CLOSED)) {
      return '#FFB8B8';
    }
    return '';
  }

  /**
   * checkIfItIsMultiRegion
   * @returns
   */
  checkIfItIsMultiRegion(): boolean {
    const ticketSelected = this.listTicket.find(e => e.ticketId == this.ticketIdSelected);
    if (ticketSelected)
      if (ticketSelected?.sectionType == Constant.MULTI) {
        return true;
      }
    return false;
  }

  checkInventory(): boolean {
    if (!this.stockSelectFromWeeklyCalendar) {
      return false;
    }
    const inventoryNumber =
      this.stockSelectFromWeeklyCalendar?.maxReservationCount - this.stockSelectFromWeeklyCalendar?.currentReservationCount;
    return inventoryNumber > 0;
  }

  checkAcceptingAppointment(): boolean {
    if (_.isEqual(this.stockSelectFromWeeklyCalendar.saleTypes, Constant.ACCEPTING_APPOINTMENTS)) {
      return true;
    }
    return false;
  }

  checkAppointmentClosed(): boolean {
    if (_.isEqual(this.stockSelectFromWeeklyCalendar.saleTypes, Constant.APPOINTMENTS_CLOSED)) {
      return true;
    }
    return false;
  }

  /**
   * checkThepriceTable
   * @returns
   */
  checkThepriceTable() {
    if (!this.stockSelectFromWeeklyCalendar) {
      return;
    }
    const yearStart = this.contentDaysWeek[0].fullDate.getFullYear();
    const yearEnd = this.contentDaysWeek[6].fullDate.getFullYear();
    const monthStart = this.contentDaysWeek[0].fullDate.getMonth();
    const monthEnd = this.contentDaysWeek[6].fullDate.getMonth();
    const ticketSelected = this.listTicket.find(e => e.ticketId == this.ticketIdSelected);
    if (yearStart == yearEnd && monthStart == monthEnd) {
      this.ticketEditorService
        .reservationPrices(
          this.informationAccount,
          null,
          this.ticketIdSelected,
          yearStart,
          monthStart + 1,
          this.stockSelectFromWeeklyCalendar.reservationClassId,
          null
        )
        .subscribe(res => {
          this.dialogService.showDialog(
            PriceTableComponent,
            {
              data: {
                listReservationPrices: res?.filter(e => e?.dynamicPriceType == this.stockSelectFromWeeklyCalendar?.dynamicPriceType),
                ticketSelected: ticketSelected,
                targetYearAndMonth: `${this.convertDate(this.contentDaysWeek[0]?.fullDate, this.languageKey)}`,
                iSMultiSection: true
              }
            },
            async result => {
              if (!result) {
                return;
              }
            }
          );
        });
    } else {
      forkJoin([
        this.ticketEditorService.reservationPrices(
          this.informationAccount,
          null,
          this.ticketIdSelected,
          yearStart,
          monthStart + 1,
          this.stockSelectFromWeeklyCalendar.reservationClassId,
          null
        ),
        this.ticketEditorService.reservationPrices(
          this.informationAccount,
          null,
          this.ticketIdSelected,
          yearEnd,
          monthEnd + 1,
          this.stockSelectFromWeeklyCalendar.reservationClassId,
          null
        )
      ]).subscribe(([firstResult, secondResult]) => {
        const combinedResults = [...firstResult, ...secondResult];
        this.dialogService.showDialog(
          PriceTableComponent,
          {
            data: {
              listReservationPrices: combinedResults.filter(
                e => e?.dynamicPriceType == this.stockSelectFromWeeklyCalendar?.dynamicPriceType
              ),
              ticketSelected: ticketSelected,
              targetYearAndMonth: `${this.convertDate(this.stockSelectFromWeeklyCalendar.reserveOn, this.languageKey)}`,
              iSMultiSection: true
            }
          },
          async result => {
            if (!result) {
              return;
            }
          }
        );
      });
    }
  }

  /**
   * normalizeDate
   * @param date
   * @returns
   */
  private normalizeDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  // Hàm để kiểm tra ngày có nằm trong khoảng không
  public isDateInRange(createdAtString: string, startDate: Date, endDate: Date): boolean {
    const createdAt = new Date(createdAtString);
    // Chuẩn hóa các ngày
    const createdAtNormalized = this.normalizeDate(createdAt);
    const startDateNormalized = this.normalizeDate(startDate);
    const endDateNormalized = this.normalizeDate(endDate);

    return createdAtNormalized >= startDateNormalized && createdAtNormalized <= endDateNormalized;
  }

  /**
   * appointmentAcceptanceStopped
   */
  async appointmentAcceptanceStopped(): Promise<void> {
    let mapItems = new Map<string, string>([
      [this.translateService.instant(`ticket-manager.tab-reservation.flight-event-ID-label`), this.stockSelectFromWeeklyCalendar?.tripId],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.reservation-date-and-time-label`),

        `${this.stockSelectFromWeeklyCalendar?.reserveOnIs29hNotation?.day}${'  '}${
          this.stockSelectFromWeeklyCalendar?.reserveOnIs29hNotation?.time
        }`
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.flight-event-name-label`),
        this.languageKey == 'en' ? this.stockSelectFromWeeklyCalendar?.name?.en : this.stockSelectFromWeeklyCalendar?.name?.ja
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.individual-ticket-name-label`),
        this.languageKey == 'en' ? this.stockSelectFromWeeklyCalendar?.ticketName?.en : this.stockSelectFromWeeklyCalendar?.ticketName?.ja
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.price-class-name-label`),
        this.languageKey == 'en'
          ? this.stockSelectFromWeeklyCalendar?.reservationClassName?.en
          : this.stockSelectFromWeeklyCalendar?.reservationClassName?.ja
      ]
    ]);
    this.dialogService.showDialog(
      DialogConfirmWithMultipleMessagesComponent,
      {
        data: {
          title: this.translateService.instant('ticket-manager.tab-reservation.stop-accepting-reservations-title'),
          message: this.translateService.instant('ticket-manager.tab-reservation.stop-accepting-reservations-content'),
          items: mapItems,
          button1: this.translateService.instant('ticket-manager.tab-reservation.stop'),
          button2: this.translateService.instant('ticket-manager.tab-reservation.close')
        }
      },
      result => {
        if (!result) {
          return;
        }
        this.ticketEditorService
          .inventoryReceptionStatusChange(this.informationAccount, this.stockSelectFromWeeklyCalendar.stockId, Constant.APPOINTMENTS_CLOSED)
          .subscribe(res => {
            if (!res) {
              return;
            }
            this.dialogService.showDialog(
              DialogConfirmWithMultipleMessagesComponent,
              {
                data: {
                  title: this.translateService.instant('ticket-manager.tab-reservation.success'),
                  message: this.translateService.instant('ticket-manager.tab-reservation.stop-accepting-reservations-success'),
                  items: mapItems,
                  button3: true
                }
              },
              async result => {
                const temp = _.cloneDeep(this.stockSelectFromWeeklyCalendar);
                await this.changeTicket();
                for (const element of this.contentDaysWeek) {
                  const stockArr = element?.stock;
                  if (stockArr && stockArr.length) {
                    const indexStock = stockArr.findIndex(item => item?.stockId == temp?.stockId);
                    if (indexStock !== -1) {
                      await this.showDetailByWeek(stockArr[indexStock]);
                    }
                  }
                }
              }
            );
          });
      }
    );
  }

  /**
   * appointmentAcceptanceResumed
   */
  async appointmentAcceptanceResumed(): Promise<void> {
    let mapItems = new Map<string, string>([
      [this.translateService.instant(`ticket-manager.tab-reservation.flight-event-ID-label`), this.stockSelectFromWeeklyCalendar?.tripId],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.reservation-date-and-time-label`),

        `${this.stockSelectFromWeeklyCalendar?.reserveOnIs29hNotation?.day}${'  '}${
          this.stockSelectFromWeeklyCalendar?.reserveOnIs29hNotation?.time
        }`
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.flight-event-name-label`),
        this.languageKey == 'en' ? this.stockSelectFromWeeklyCalendar?.name?.en : this.stockSelectFromWeeklyCalendar?.name?.ja
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.individual-ticket-name-label`),
        this.languageKey == 'en' ? this.stockSelectFromWeeklyCalendar?.ticketName?.en : this.stockSelectFromWeeklyCalendar?.ticketName?.ja
      ],
      [
        this.translateService.instant(`ticket-manager.tab-reservation.price-class-name-label`),
        this.languageKey == 'en'
          ? this.stockSelectFromWeeklyCalendar?.reservationClassName?.en
          : this.stockSelectFromWeeklyCalendar?.reservationClassName?.ja
      ]
    ]);
    this.dialogService.showDialog(
      DialogConfirmWithMultipleMessagesComponent,
      {
        data: {
          title: this.translateService.instant('ticket-manager.tab-reservation.resuming-reservations-title'),
          message: this.translateService.instant('ticket-manager.tab-reservation.resuming-reservations-content'),
          items: mapItems,
          button1: this.translateService.instant('ticket-manager.tab-reservation.resuming'),
          button2: this.translateService.instant('ticket-manager.tab-reservation.close')
        }
      },
      result => {
        if (!result) {
          return;
        }
        this.ticketEditorService
          .inventoryReceptionStatusChange(
            this.informationAccount,
            this.stockSelectFromWeeklyCalendar.stockId,
            Constant.ACCEPTING_APPOINTMENTS
          )
          .subscribe(res => {
            if (!res) {
              return;
            }
            this.dialogService.showDialog(
              DialogConfirmWithMultipleMessagesComponent,
              {
                data: {
                  title: this.translateService.instant('ticket-manager.tab-reservation.success'),
                  message: this.translateService.instant('ticket-manager.tab-reservation.resuming-reservations-success'),
                  items: mapItems,
                  button3: true
                }
              },
              async result => {
                const temp = _.cloneDeep(this.stockSelectFromWeeklyCalendar);
                await this.changeTicket();
                for (const element of this.contentDaysWeek) {
                  const stockArr = element?.stock;
                  if (stockArr && stockArr.length) {
                    const indexStock = stockArr.findIndex(item => item?.stockId == temp?.stockId);
                    if (indexStock !== -1) {
                      await this.showDetailByWeek(stockArr[indexStock]);
                    }
                  }
                }
              }
            );
          });
      }
    );
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }

  /**
   * cancelUserRefundApproval
   */
  async cancelUserRefundApproval(): Promise<void> {
    this.dialogService.showDialog(
      DialogSetUpARefundCertificateComponent,
      {
        data: {
          mode: Constant.MODE_CANCEL_USER_REFUND_APPROVAL,
          stock: this.stockSelectFromWeeklyCalendar
        }
      },
      async result => {
        if (!result) {
          return;
        }
        const temp = _.cloneDeep(this.stockSelectFromWeeklyCalendar);
        await this.changeTicket();
        for (const element of this.contentDaysWeek) {
          const stockArr = element?.stock;
          if (stockArr && stockArr.length) {
            const indexStock = stockArr.findIndex(item => item?.stockId == temp?.stockId);
            if (indexStock !== -1) {
              await this.showDetailByWeek(stockArr[indexStock]);
            }
          }
        }
      }
    );
  }

  /**
   * setUserRefundApproval
   */
  async setUserRefundApproval(): Promise<void> {
    this.dialogService.showDialog(
      DialogSetUpARefundCertificateComponent,
      {
        data: {
          mode: Constant.MODE_SET_USER_REFUND_APPROVAL,
          stock: this.stockSelectFromWeeklyCalendar
        }
      },
      async result => {
        if (!result) {
          return;
        }
        const temp = _.cloneDeep(this.stockSelectFromWeeklyCalendar);
        await this.changeTicket();
        for (const element of this.contentDaysWeek) {
          const stockArr = element?.stock;
          if (stockArr && stockArr.length) {
            const indexStock = stockArr.findIndex(item => item?.stockId == temp?.stockId);
            if (indexStock !== -1) {
              await this.showDetailByWeek(stockArr[indexStock]);
            }
          }
        }
      }
    );
  }

  /**
   * setTicketQuantityDisplay
   */
  setTicketQuantityDisplay() {
    this.commonTableService.getValueCommonTableByKey(Constant.KEY_TICKET_QUANTITY_DISPLAY_SETTINGS).subscribe(result => {
      this.dialogService.showDialog(
        DialogTicketQuantityDisplaySettingsComponent,
        {
          data: {
            commonTable: result
              ? result
              : new CommonTable(Constant.KEY_TICKET_QUANTITY_DISPLAY_SETTINGS, JSON.stringify(new TicketQuantityDisplaySetting(true)))
          }
        },
        result => {
          if (result) {
            this.ticketQuantityDisplaySetting = JSON.parse(result.value);
            this.isSoldTickets = this.ticketQuantityDisplaySetting.isSoldTicket;
          }
        }
      );
    });
  }

  /**
   * ticketStatusLabel
   * @returns
   */
  ticketStatusLabel(): string {
    const key = this.isSoldTickets ? 'ticket-manager.tab-reservation.sold' : 'ticket-manager.tab-reservation.remaining';
    return this.translateService.instant(key);
  }
}
